import { useForm } from 'react-hook-form';
import { PrimaryButton, SecondaryButton } from '@weareopenr/component-library';
import { ButtonContainer } from 'src/components/ButtonContainer/ButtonContainer';
import { PriceSchemeNameInput } from '../../PriceSchemeNameInput';

type Props = {
  submitting: boolean;
  cancelText: string;
  onCancel: () => void;
  onSubmit: (t: TSelectPriceSchemeSchema['name']) => void;
};

type TSelectPriceSchemeSchema = {
  name?: string;
};

const CreateSchemeStep = ({ onCancel, onSubmit, cancelText, submitting }: Props) => {
  const formFields = useForm<TSelectPriceSchemeSchema>({
    defaultValues: { name: undefined },
  });
  const { formState, handleSubmit, watch } = formFields;

  const submitForm = ({ name }: TSelectPriceSchemeSchema) => onSubmit(name);

  const { name } = watch();

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <PriceSchemeNameInput formFields={formFields} />
      <ButtonContainer
        left={
          <SecondaryButton
            data-cy="cancel-button"
            type="button"
            buttonStyle="outline"
            onClick={onCancel}
            size="full-width"
          >
            {cancelText}
          </SecondaryButton>
        }
        right={
          <PrimaryButton
            data-cy="create-button"
            loading={submitting}
            disabled={!formState.isDirty || !name?.length}
            size="full-width"
            type="submit"
          >
            Create
          </PrimaryButton>
        }
      />
    </form>
  );
};

export default CreateSchemeStep;
